window.addEventListener("beforeunload", function() {
    $(".blackout").show();
    $(".site-loading-icon").css("display", "flex");

});

$(document).ready(function() {

    // consentObj definieren, da es im eventTracking.js verwendet wird
    window.consentObj = {};

    //wenn mit Hash latlon oder mit Parameter Location übergeben wird soll der latlon an alle Links im Terminal angehängt werden (Logo, Menü, Listen)
    var latlon;

    if (getHashParameter('latlon').length > 0) {
        latlon = getHashParameter('latlon');
    } else if ($('#ttg-tdTerminalContent section .resultSet').data('latlon')) {
        latlon = $('#ttg-tdTerminalContent section .resultSet').data('latlon');
    }

    $('#ttg-tdTerminalContent section .resultSet').attr('data-latlon', latlon);

    $("a[href^='/'], a[href^='https://terminal.ttg.at'], a[href^='https://terminal.ttg.at.ddev.site'], a[href^='https://feature-terminal.ttg.at']").each(function() {
        var $this = $(this);
        var _href = $this.attr("href");
        if ($this.prop("hash").indexOf("latlon") == -1) {
            if ($this.prop("hash").length > 0) {
                $this.attr("href", _href + "&latlon=" + latlon);
            } else {
                $this.attr("href", _href + "#latlon=" + latlon);
            }
        }
    });

    $('body').addClass($('#ttg-tdTerminalHeader').prop('class'));

    var logoWidthMargin = (($('#ttg-tdTerminalHeader .logos').width() - 10) / 2) * -1;
    $('#ttg-tdTerminalHeader.standard .logos').css({
        'margin-left': logoWidthMargin + 'px',
        'visibility': 'visible'
    });

    $('#ttg-tdTerminalHeader #menu .showMenu').click(function(e) {
        e.preventDefault();
        $('body').addClass('menu-is-visible');
    });

    $('#ttg-tdTerminalHeader #menu .hideMenu').click(function(e) {
        e.preventDefault();
        $('body').removeClass('menu-is-visible');
    });

    $('a:not([href^="https://terminal.ttg.at"]):not([href^="#"]):not([href^="/"]):not([href^="javascript:history.back()"])').addClass('notClickable');

    $('a[href="#mailto"]').addClass('notClickable');

    var getTerminalMetaResult = function() {

        var $resultSet = $(this);

        var languageId = 0;
        if ($('html').attr('lang') == "en") {
            languageId = 1;
        }

        $.ajax({
            method: 'POST',
            url: "/index.php?id=" + rootPage + "&L=" + languageId + "&tdType=" + $resultSet.data('type') + "&type=" + $resultSet.data('typenum'),
            data: {
                type: $resultSet.data('typenum'),
                pluginUid: $resultSet.data('pluginuid'),
                pageId: $resultSet.data('pageid'),
                latlon: $resultSet.data('latlon'),
                lang: $('html').attr('lang'),
                metaConfig: $resultSet.data('metaconfig')
            },
            beforeSend: function(xhr, o) {

                var $loading = $('<div />').addClass('lds-ellipsis-loader').html('<div /><div /><div /><div />');
                $resultSet.html($loading);

            },
            success: function(response, status, xhr) {

                // console.log('SUCCESS');
                // console.log(response);
                // console.log(status);
                // console.log(xhr);
                $resultSet.html(response);

            },
            error: function(xhr, status, error) {

                //console.log('ERROR');
                //console.log(xhr);
                //console.log(status);
                //console.log(error);

            },
            complete: function(xhr, status) {

                //console.log('COMPLETE');
                //console.log(xhr);
                //console.log(status);
                var width = $resultSet.width();
                var widthOfBoxes = $resultSet.find('.box').width() + 20;
                var slides2show = Math.floor(width / widthOfBoxes);
                // console.log(slides2show);
                if ($resultSet.find('.boxes .box').length) {

                    $resultSet.find('.boxes').slick({
                        slidesToShow: slides2show,
                        variableWidth: true,
                        swipeToSlide: true,
                        infinite: false,
                        prevArrow: '<a href="#" class="left"><span class="fa-regular fa-angle-left"></span></a>',
                        nextArrow: '<a href="#" class="right"><span class="fa-regular fa-angle-right"></span></a>'
                    });

                } else {

                    // Handling wenn keine ResultItems im Response
                    $resultSet.closest('section').hide();

                }

            }
        });

    };

    $.each($('#ttg-tdTerminalContent section .resultSet'), getTerminalMetaResult);

    if ($('#sliderHeader li').length <= 1) {
        $('#sliderHeader .carousel-controls').hide();
    }

    // Bei mobilen Endgeräten darf der Klick auf das Sprachwechsler-Symbol nicht gleich den Link aufrufen
    $('ul.langSwitcher li.active').click(function(e) {
        e.preventDefault();
        $("li.inactive").show();
    });

    $(window).on("scroll", function() {
        if (($(document).height() - ($(window).height() + $(window).scrollTop())) / $(document).height() === 0) {
            $(".scroll-arrow").addClass("hidden");
        } else if ((($(document).height() - ($(window).height() + $(window).scrollTop())) / $(document).height() != 0) && $(".scroll-arrow").hasClass("hidden")) {
            $(".scroll-arrow").removeClass("hidden");
        }
    });
});

//All AJAX requests completed
$(document).ajaxStop(function() {
    var latlon;

    if (getHashParameter('latlon').length > 0) {
        latlon = getHashParameter('latlon');

        $("a[href^='/'], a[href^='https://terminal.ttg.at'], a[href^='https://feature-terminal.ttg.at'], a[href^='https://terminal.ttg.at.ddev.site']").each(function() {
            var $this = $(this);
            var _href = $this.attr("href");
            if ($this.prop("hash").indexOf("latlon") == -1) {
                if ($this.prop("hash").length > 0) {
                    $this.attr("href", _href + "&latlon=" + latlon);
                } else {
                    $this.attr("href", _href + "#latlon=" + latlon);
                }
            }
        });
    }

});